operations:
  load-models: 모델 불러오기
  load-models-status:
    loading: 불러오는 중
    ready: 준비됨
docs:
  theme:
    navbar:
      appearance:
        title: 스타일 및 모양
'controls-island':
  'fade-on-hover':
    enable: 자동 숨기기
    disable: 항상 표시
  'chat-bubble':
    enable: 채팅 말풍선 표시
    disable: 채팅 말풍선 숨기기
  'open-settings': 설정 열기
  'open-chat': 채팅 열기
  'refresh': 새로고침
  'open-hearing-controls': 듣기 제어 열기
  'drag-to-move-window': 드레그하여 창 이동
  'switch-to-light-mode': 라이트 모드로 전환
  'switch-to-dark-mode': 다크 모드로 전환
  'pin-on-top': 맨 위에 고정
  'unpin-from-top': 맨 위 고정 해제
  'switch-profile': 프로필 전환
  'close': 닫기
  'expand': 확장
  'collapse': 접기
  'login': 가입하기
  'logging-in': 로그인 중...
  'account': 계정
  'logout': 로그아웃
widgets:
  close: Close widget
  empty:
    title: No widget active
    description: Widgets will appear here when a tool or plugin spawns one.
  loading: Loading widget…
  waiting: Waiting for widget data for "{id}"…
notice:
  'fade-on-hover':
    title: 호버 시 페이드
    intro: 커서가 근처를 돌아다니면 캐릭터가 자동으로 페이드됩니다. 캐릭터가 눈에 띄게 유지되면서 방해 요소를 줄이는 데 도움이 됩니다.
    opacity: 전원을 켜면 커서가 가까이 있을 때 두 {targets} 모두에 대해 불투명도가 {value}으로 떨어집니다.
    toggle: '{controls}에서 마우스를 누른 후 {icon}을 다시 클릭하여 끌 수 있습니다.'
    controls-label: 제어 섬
    icon-label: eye-slash 아이콘
    value: '0'
    targets: 캐릭터 및 UI
    confirm: 확인
    dont-show-again: 다시 표시하지 않기
    preparing: 준비 중…
    read-more: 더 보기
    preview-title: 이게 뭐죠?
about:
  subtitle: 데스크탑 버전
  current-version: 현재 버전
  common:
    cancel: 취소
  links:
    title: 링크
    home: 홈
    documentation: 문서
    github: Github
  update:
    lane:
      label: 업데이트 라인
      description: 따라갈 릴리즈 채널을 선택하세요
      placeholder: 릴리즈 라인 선택
    channels:
      auto: 자동
      stable: 안정
      alpha: 알파
      beta: 베타
      nightly: 실험적
      canary: 카나리아
    status:
      downloading: 업데이트 다운로드 중...
      error-prefix: 에러
      latest: 최신 버전 (v{version}).
      downloaded:
        windows: 조용히 설치할 준비가 되었어요 (v{version}).
        restart: 재시작시 업데이트를 설치할 준비가 되었어요 (v{version}).
    actions:
      download: 업데이트 다운로드
      download-short: 다운로드
      confirm-download: 다운로드 확인
      check-for-updates: 업데이트 확인하기
      checking: 확인 중...
      latest-version: 최신 버전
      disabled-dev: Updates disabled in Dev
      retry-check: 다시 확인하기
      restart-silent: 재 시작 후 조용히 업데이트하기
      restart-install: 재시작 후 업데이트하기
      confirm-restart: 정말 재 시작할까요
    dialog:
      title: 업데이트 사용 가능
      description: 새로운 버전 (v{version})이 이용 가능해요.
      no-release-notes-markdown: _No release notes provided._
